module.exports = __webpack_public_path__ + "img/lost_disable.b9f57855.png";